/*
 * Module for the participant common area
*/

rs.module("application/sections/participant/commonarea",

    [],

    function () {

        var _jsSelectors;
        var _cssClasses;
        var _backendUrls;
        var _isInitialized = false;
        var _idLoaded;

        var _currentBenefit;
        var _benefitDropDown;

        var _currentRole;
        var _rolesDropDown;

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses, backendUrls, benefitPickerDisabled, idLoaded) {

            _jsSelectors = jsSelectors;
            _cssClasses = cssClasses;
            _backendUrls = backendUrls;
            _isInitialized = true;
            _idLoaded = idLoaded;

            // benefit picker elements
            _currentBenefit = $.js(_jsSelectors.currentBenefit, { required:false });
            _benefitDropDown = $.js(_jsSelectors.benefitDropDown, { required:false });
            var benefitListItems = _benefitDropDown.js(_jsSelectors.benefitItem, { required: false, multiple: true });

            // roles drop down elements
            _currentRole = $.js(_jsSelectors.currentRole);
            _rolesDropDown = $.js(_jsSelectors.rolesDropDown, { required: false });
            var roleItems = _rolesDropDown.js(_jsSelectors.roleItem, { required: false, multiple: true });

            // Only hook up benefit list listeners if control is not disabled
            if (!benefitPickerDisabled) {
                // Show/hide drop down when benefit picker has focus
                _currentBenefit.focus(function () { _toggleDropDown(_benefitDropDown, true); });
                _currentBenefit.blur(function () { _toggleDropDown(_benefitDropDown, false); });
            }

            // Show/hide drop down when role picker has focus
            _currentRole.focus(function() { _toggleDropDown(_rolesDropDown, true); });
            _currentRole.blur(function() { _toggleDropDown(_rolesDropDown, false); });

            // Due to the order event handlers get executed, the blur event on the current role fires before the click event of the role items.
            // Because of this, the blur handler ends up hiding the drop down before the click event fires, which results in clicking a role list item doing nothing
            // However, since the mousedown event fires just before the blur event, we are able to suppress the default behavior of hiding the drop down on blur.
            // Then, when the click event fires, we will hide the drop down at that point
            benefitListItems.mousedown(event, function () { event.preventDefault(); });

            // Needed for same reason as benefitListItems.mousedown (above)
            roleItems.mousedown(event, function () { event.preventDefault(); });

            // Replace current benefit when a new benefit is selected
            benefitListItems.click(event, function () { _setCurrentBenefitDisplay($(this).html()); });

            // Replace current role when a new role is selected
            roleItems.click(event, function () { _setCurrentRoleDisplay(); });

            $.js(_jsSelectors.idCardLink, { required: false }).click(_displayIdCard);
        }

        //
        // Toggle the visibilty of a drop down
        //
        function _toggleDropDown(dropdown, visible) {
            dropdown.toggleClass(_cssClasses.visible, visible);
        }

        //
        // Display the new current benefit and hide the drop down
        //
        function _setCurrentBenefitDisplay(benefit) {
            _currentBenefit.js(_jsSelectors.currentBenefitText).html(benefit);
            _currentBenefit.blur();
        }

        //
        // Display the new role and hide the drop down
        //
        function _setCurrentRoleDisplay() {
            _currentRole.js(_jsSelectors.roleItemText).text("Redirecting...");
            _currentRole.blur();
        }

        //
        // Display the id card
        //
        function _displayIdCard() {

            // close the common area menu when the id card opens
            rs.module("application/sections/participant/commonarea/commonareaquickmenu").closeMenu();

            $(this).toggleClass(_cssClasses.active);

            $.js(_jsSelectors.idCard, { required: false }).toggle();

            if (!_idLoaded) {

                $.get(_backendUrls.getIdCard).done(function (result) {

                    $.js(_jsSelectors.idCard, { required: false }).html(result);
                });

                _idLoaded = true;
            }
        }

        //
        // Exported function to allow other js modules to close the ID Card
        //
        function closeIdCard() {

            if (_isInitialized) {

                $.js(_jsSelectors.idCardLink, { required: false }).removeClass(_cssClasses.active);
                $.js(_jsSelectors.idCard, { required: false }).hide();
            }
        }

        // Exported public API
        var exports = {
            initialize,
            closeIdCard
        };

        return exports;
    }
);